import axios from 'axios';
import { getB2CToken } from '../utils/b2c-utils';

export const authApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

const ormaApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

ormaApi.interceptors.request.use(
  async (config) => {
    const token = await getB2CToken();

    if (token !== null) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  }
);

export default ormaApi;
